import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend } from 'recharts';
import styled from 'styled-components';
import Theme from '../../../styles/Theme/Theme';
import CustomIcon from '../Icons/CustomIcon';
import { BusDelayed } from "../../../assets/iconsMapPNG/_index";
import * as SLAIcons from "../../../assets/iconsSLAMatch/_index";

const TextChart = styled.text`
    font-size: ${props => (Theme.typography.fontSize[props.fontSize + '_tablet'])};
    @media ${Theme.devices.desktop} {
        font-size: ${props => (Theme.typography.fontSize[props.fontSize + '_desktop'])}
     }
      @media ${Theme.devices.videowall} {
         font-size: ${props => (Theme.typography.fontSize[props.fontSize + '_videowall'])}
      }
`;
const isVideowall = window.matchMedia(Theme.devices.videowall).matches;
const windowWidth = window.innerWidth;
const LabelsFontSize = 'text_xl';


export const RadarChartComponent = (props) => {
    const data = props.data;

    const CustomIcons = (props) => {

        const { x, y, cx, cy, payload, textAnchor, icons, ...rest } = props;
        const { value } = payload;

        let iconToShow;

        icons.map((el, idx) => {
            if (idx == payload.index) iconToShow = el.icon
        })

        let iconSize = 20;
        let margin = 5;
        let marginToIcon = 5;
        // Calculate the width of the label text
        let textWidth = value.toString().length;
        let getFont = Theme.typography.fontSize[LabelsFontSize + '_videowall'];
        const numericValue = parseFloat(getFont.match(/[\d\.]+/)[0]);
        let fontSizeLabel = numericValue * windowWidth / 100
        let widthLabel = textWidth * fontSizeLabel;

        let topLabelOffset = - (1.2 * iconSize);
        let topIconXOffset = 5;
        let topIconYOffset = 5;
        let leftIcosnOffset = 0

        if (isVideowall) {
            iconSize = 48;
            margin = 40;
            marginToIcon = 40;
            topLabelOffset = -(1 * iconSize);
            topIconYOffset = 15;
            leftIcosnOffset = iconSize;
        }


        // Calculate the angle based on x and y values
        const angle = Math.atan2(y - cy, x - cx) * 180 / Math.PI;

        const isLeftSide = angle < -90 || angle > 90;
        const isTopSide = angle == -90 || angle == 90;

        //const xOffset = isLeftSide ? -margin : margin + iconSize + marginToIcon;
        const xOffset = isLeftSide ? -margin - iconSize - marginToIcon : margin + iconSize + marginToIcon;
        const xOffsetTop = isTopSide ? 0 : xOffset
        const yOffsetTop = isTopSide ? topLabelOffset*2 : topIconYOffset

        // Calculate the x coordinate of the icon based on the width of the label text
        //const iconX = isLeftSide ? -widthLabel + leftIcosnOffset : margin; //THIS DOES NOT MAKE SENSE
        const iconX = isLeftSide ? - margin - iconSize : margin; //THIS DOES NOT MAKE SENSE
        const iconXTop = isTopSide ? isVideowall ? -iconX/2 : -iconX : iconX;
        const iconYTop = isTopSide ? topLabelOffset - margin/2 : -iconSize / 2;

        return (
            <g transform={`translate(${x},${y})`} key={`label-${props.index}`}>

                <image
                    xlinkHref={SLAIcons[iconToShow]}
                    x={iconXTop} // Adjust the x coordinate of the icon to position it to the left of the label
                    y={iconYTop}
                    width={iconSize}
                    height={iconSize}
                />
                <TextChart {...rest}
                    x={xOffsetTop} // Adjust the x coordinate of the label text to align it with the icon
                    y={yOffsetTop} // Adjust the y coordinate of the label text to move it away from the center
                    textAnchor={textAnchor}// Adjust the text anchor based on the angle of the label
                    fontSize={LabelsFontSize}>
                    {value}</TextChart>

            </g>
        )
    }

    return (
        <ResponsiveContainer>
            {/* <Legenda data={data} icons={props.icons}/> */}
            <RadarChart outerRadius="50%" data={data} width='100%' height='100%'>
                <PolarAngleAxis dataKey="name" tick={<CustomIcons icons={props.icons} />} />
                <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} cx='100' />
                <Radar name="Objectivo" dataKey='sla_top' stroke="#d1ecff" fill={Theme.color['blue-1']} isAnimationActive={false} />
                <Radar dataKey='sla_obj' stroke="white" fill="white" isAnimationActive={false} />
                <PolarGrid stroke={Theme.color['blue-1']} />
                <Radar name="Sla" dataKey='sla' stroke="#8884d8" fill="#7326D3" fillOpacity={0.6} isAnimationActive={false} />
            </RadarChart>
        </ResponsiveContainer>
    )
}